/**
 * Unique values in the client (keepr-api utils/uniqueValues.js; docs/plans/
 * data-types-second-pass.md §3.3). The server holds the rule — a value another
 * item of the card already has is 409 `duplicate_value { element, value,
 * itemId?, title? }`, or a row error of the same code — and names the holder
 * only when the person can read it. This turns that refusal into the plain
 * sentence the form puts under the field and the toast repeats.
 */

/** The element's label, or its name. */
function labelOf(elements, name) {
	const def = (elements || []).find(entry => entry && entry.name === name);
	return (def && def.label && def.label.singular) || name || 'This value';
}

/**
 * describeDuplicateValue(data, { elements }) ->
 *   { element, text, toast, holder: { itemId, title } | null }
 *
 * `text` is what sits under the field when no holder can be named ("Another
 * item already has this value."); with a holder the form shows "Already used
 * by" and the holder's badge. `toast` is the sentence either way, in words.
 */
export function describeDuplicateValue(data, { elements = [] } = {}) {
	const element = data && data.element ? String(data.element) : null;
	const label = labelOf(elements, element);
	const holder = data && data.itemId ? { itemId: String(data.itemId), title: data.title ? String(data.title) : '' } : null;
	const text = holder ? 'Already used by' : 'Another item already has this value.';
	const toast = holder
		? `${label} must be unique, and ${holder.title ? `“${holder.title}”` : 'another item'} already has this value.`
		: `${label} must be unique, and another item already has this value.`;
	return { element, text, toast, holder };
}

/** Is this axios error the unique-values refusal? */
export const isDuplicateValue = error => error?.response?.status === 409 && error?.response?.data?.code === 'duplicate_value';
